import { Injectable } from '@angular/core';
import { buildFormModelOperation } from 'src/app/models/mocks/form-model.mock';
import {
	CONNECTION_TYPE,
	EVALUATION_TYPE,
	IBankScoringConfig,
	IIrpfConfig,
	IOperation,
	IProcessConfig,
	IScriptureConfig,
	IWorkLifeConfig,
	MODE,
	OPERATION_STATUS,
	OPERATION_TYPE,
} from '../models/user-identification';

@Injectable({
	providedIn: 'root',
})
export class ProcessTestsHelperService {
	constructor() {}

	public getTestsOperations(data: {
		iframe: boolean;
		operations: Array<OPERATION_TYPE>;
		type?: CONNECTION_TYPE;
	}): Array<IOperation> {
		let operations: Array<IOperation> = [
			{
				type: OPERATION_TYPE.FINISH,
				config: {
					iframe: data.iframe,
					status: OPERATION_STATUS.KO,
					redirect: 'https://www.google.com',
					redirect_ko: 'https://www.google.com/search?q=error',
				},
				completed: false,
				uuid: 'uuid-finish-12345',
			},
		];
		if (data?.operations?.length) {
			if (data?.operations.includes(OPERATION_TYPE.POL)) {
				operations.unshift({
					type: OPERATION_TYPE.POL,
					config: {
						mode: MODE.AUTO,
						iframe: data.iframe,
						tutorial: true,
						fraud_scoring: false,
						fallback: {
							type: MODE.MANUAL,
							validation: MODE.MANUAL,
						},
					},
					completed: false,
					uuid: 'uuid-pol-12345',
				});
			}
			if (data?.operations.includes(OPERATION_TYPE.OCR)) {
				operations.unshift({
					type: OPERATION_TYPE.OCR,
					config: {
						mode: MODE.AUTO,
						iframe: data.iframe,
						tutorial: true,
						midni_validation_enabled: true,
						fraud_scoring: {
							aeat: false,
							legal_age: 20,
							expirated: true,
							valid_country: true,
							aml: false,
							pep: false,
							manipulated_photo: {
								blocking_step: false,
								ip_block: false,
								identifier_block: false,
								email_alert: 'rafael.cruz@tecalis.com',
							},
							photocopy_check: {
								blocking_step: false,
								ip_block: false,
								identifier_block: false,
								email_alert: 'rafael.cruz@tecalis.com',
							},
							screen_photo: {
								blocking_step: false,
								ip_block: false,
								identifier_block: false,
								email_alert: 'rafael.cruz@tecalis.com',
							},
						},
						allowed_docs: { dni: ['ESP', 'FRA', 'ITA'], passport: [], nie: true },
						not_allowed_docs: { dni: [], passport: ['ESP', 'FRA'] },
						setting: {
							show_guide: true,
							side_max_time: 150,
							total_tries: 1,
						},
					},
					completed: false,
					uuid: 'uuid-ocr-12345',
				});
			}
			if (data?.operations.includes(OPERATION_TYPE.OCR_CANNY)) {
				operations.unshift({
					type: OPERATION_TYPE.OCR_CANNY,
					config: {
						mode: MODE.AUTO,
						iframe: data.iframe,
						tutorial: true,
						fraud_scoring: false,
					},
					completed: false,
				});
			}
			if (data?.operations.includes(OPERATION_TYPE.DOCUMENTS)) {
				operations.unshift({
					type: OPERATION_TYPE.DOCUMENTS,
					config: {
						iframe: data.iframe,
						docs: [
							{
								uuid: '0198efb0-ac9a-7b74-b7e1-f2cdb0546cbd',
								document_type_uuid: '01994c25-4beb-745d-85ef-d0aaf8a63693',
								type: 'DRIVE_LICENSE',
								required: true,
								method: 'photo',
								min: 1,
								max: 1,
								title: null,
								description: null,
								instructions: null,
								instructions_photo: null,
								preview_validation: null,
								match_data: null,
							},
							{
								uuid: '0198efb0-ac9a-7b74-b7e1-f2cdb0546cbd',
								document_type_uuid: '01994c25-4beb-745d-85ef-d0aaf8a63693',
								type: 'DRIVE_LICENSE',
								required: true,
								method: 'photo',
								min: 1,
								max: 1,
								title: null,
								description: null,
								instructions: null,
								instructions_photo: null,
								preview_validation: null,
								match_data: null,
							},
						],
					},
					completed: false,
					uuid: 'uuid-documents-12345',
				});
				/*
				operations.unshift({
					type: OPERATION_TYPE.HOME,
					config: {
						tecalis_policy_check: true,
						policy_checks: [],
						description: 'DOCS',
					},
					completed: false,
					uuid: 'uuid-bank-scoring-12345',
				});
				*/
			}
			if (data?.operations.includes(OPERATION_TYPE.CHOOSE)) {
				operations.unshift({
					type: OPERATION_TYPE.CHOOSE,
					uuid: '',
					config: {
						description: '',
						operations: [
							{
								type: OPERATION_TYPE.CONNECTIONS,
								config: {
									connection_type_uuid: '',
									type: CONNECTION_TYPE.BANK_SCORING,
									mode: MODE.AUTO,
									evaluation: EVALUATION_TYPE.MATCH_DATA,
									iban: 'ES1000492352082414205416',
									total_tries: 2,
								},
								completed: false,
								uuid: 'uuid-bank-scoring-12345',
							},
							{
								type: OPERATION_TYPE.CONNECTIONS,
								config: {
									connection_type_uuid: '',
									type: CONNECTION_TYPE.WORK_LIFE,
									fallback: {
										type: MODE.MANUAL,
										validation: MODE.AUTO,
									},
									mode: MODE.AUTO,
									evaluation: EVALUATION_TYPE.SCORING,
									total_tries: 2,
								},
								completed: false,
								uuid: 'uuid-work-life-12345',
							},
							{
								type: OPERATION_TYPE.CONNECTIONS,
								config: {
									connection_type_uuid: '',
									type: CONNECTION_TYPE.IRPF,
									fallback: {
										type: MODE.MANUAL,
										validation: MODE.AUTO,
									},
									mode: MODE.AUTO,
									evaluation: EVALUATION_TYPE.SCORING,
									total_tries: 2,
								},
								completed: false,
								uuid: 'uuid-irpf-12345',
							},
						],
					},
					completed: false,
				});
				/*
				operations.unshift({
					type: OPERATION_TYPE.HOME,
					config: {
						tecalis_policy_check: true,
						policy_checks: [],
						description: 'Choose',
					},
					completed: false,
					uuid: 'uuid-home-12345',
				});
				*/
			}
			if (data?.operations.includes(OPERATION_TYPE.FORM)) {
				operations.unshift(buildFormModelOperation());
			}
			if (data?.operations.includes(OPERATION_TYPE.CONNECTIONS)) {
				switch (data?.type) {
					case CONNECTION_TYPE.WORK_LIFE:
						operations.unshift({
							type: OPERATION_TYPE.CONNECTIONS,
							config: {
								type: CONNECTION_TYPE.WORK_LIFE,
								fallback: {
									type: MODE.MANUAL,
									validation: MODE.AUTO,
								},
								evaluation: EVALUATION_TYPE.SCORING,
								total_tries: 2,
							} as IWorkLifeConfig,
							completed: false,
							uuid: 'uuid-work-life-12345',
						});
						break;
					case CONNECTION_TYPE.BANK_SCORING:
						operations.unshift({
							type: OPERATION_TYPE.CONNECTIONS,
							config: {
								type: CONNECTION_TYPE.BANK_SCORING,
								match_name: true,
								// NO debería llegarnos completo
								iban: 'ES1000492352082414205416',
								ruleset: 'default',
								evaluation: EVALUATION_TYPE.SCORING,
								total_tries: 2,
							} as IBankScoringConfig,
							completed: false,
							uuid: 'uuid-bank-scoring-12345',
						});
						/*
						operations.unshift({
							type: OPERATION_TYPE.HOME,
							config: {
								tecalis_policy_check: true,
								policy_checks: [],
								description: 'Bank scoring',
							},
							completed: false,
							uuid: 'uuid-bank-scoring-12345',
						});
						*/
						break;
					case CONNECTION_TYPE.IRPF:
						operations.unshift({
							type: OPERATION_TYPE.CONNECTIONS,
							config: {
								type: CONNECTION_TYPE.IRPF,
								evaluation: EVALUATION_TYPE.SCORING,
								fallback: {
									type: MODE.MANUAL,
									validation: MODE.AUTO,
								},
								total_tries: 2,
							} as IIrpfConfig,
							completed: false,
							uuid: 'uuid-irpf-12345',
						});
						/*
						operations.unshift({
							type: OPERATION_TYPE.HOME,
							config: {
								tecalis_policy_check: true,
								policy_checks: [],
								description: 'IRPF',
							},
							completed: false,
							uuid: 'uuid-home-irpf-12345',
						});
						*/
						break;
					case CONNECTION_TYPE.SCRIPTURE:
						operations.unshift({
							type: OPERATION_TYPE.CONNECTIONS,
							config: {
								type: CONNECTION_TYPE.SCRIPTURE,
								fallback: {
									type: MODE.MANUAL,
									validation: MODE.AUTO,
								},
								evaluation: EVALUATION_TYPE.MATCH_DATA,
								total_tries: 2,
							} as IScriptureConfig,
							completed: false,
							uuid: 'uuid-scripture-12345',
						});
						break;
				}
			}
		}
		return operations;
	}

	get processTestsConfig(): IProcessConfig {
		return {
			allowed_device: ['mobile', 'pc'],
			version: '3',
			metadata: {
				foo: 'bar',
				enabled: true,
				delayed_process_warning_visibility: 'start_and_resume',
			},
			location: 'enabled',
			media_expiry: 168,
			include_images: true,
			required_recording: false,
			has_saved_state: true,
			delayed_process_warning: false,
			delayed_process_warning_visibility: null,
			delayed_process_warning_text: null,
			notify: {
				email: {
					to: '',
					template: 'd-56760daa92d54fc2839b7ba2297cc574',
					subject: 'Test Notification',
					from: 'no-reply@example.com',
					from_name: 'Tecalis',
				},
				sms: {
					phone: '',
					sms_text: 'default sms text',
					sms_from: '+34666666661',
				},
			},
			antifraud: {
				ip_block: true,
				ip_block_global: false,
				identifier_block: true,
				identifier_block_global: false,
				face_block: true,
				face_block_global: false,
				block_operation: true,
				email_alert: null,
			},
			validation: {
				type: MODE.AUTO,
				emails: null,
			},
			sdk: false,
			isDeviceAllowed: true,
		};
	}

	get processTestsDesign(): any {
		return {
			skin: 'light',
			logo: null,
			css_config: null,
			title: 'Tecalis',
			theme_color: '#ffffff',
			watermark: true,
			show_product_name: false,
			custom_spinner: null,
		};
	}
}
